import { Dispatch, useEffect, useState } from "react";
import { Editable } from "@ark-ui/react";
import { PencilIcon, CheckIcon, XIcon } from "lucide-react";

import styles from "./editable-label.module.css";

export function EditableLabel({
  value,
  onValueChange,
  placeholder,
}: {
  value: string;
  onValueChange: Dispatch<string>;
  placeholder?: string;
}) {
  const [liveValue, setLiveValue] = useState(value);
  useEffect(() => setLiveValue(value), [value]);
  return (
    <Editable.Root
      value={liveValue}
      onValueChange={(e) => setLiveValue(e.value)}
      onValueCommit={(e) => onValueChange(e.value)}
      placeholder={placeholder}
      className={styles.editableLabel}
    >
      <Editable.Area>
        <Editable.Input />
        <Editable.Preview />
        <Editable.EditTrigger type="button">
          <PencilIcon size={16} strokeWidth={1.5} />
        </Editable.EditTrigger>
        <Editable.SubmitTrigger type="button">
          <CheckIcon size={16} strokeWidth={1.5} />
        </Editable.SubmitTrigger>
        <Editable.CancelTrigger type="button">
          <XIcon size={16} strokeWidth={1.5} />
        </Editable.CancelTrigger>
      </Editable.Area>
    </Editable.Root>
  );
}
